import {apiV2Link, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IMapOfferSidebar} from "../map/types/MapOfferSidebar";
import {IOfferDetail} from "../types/IOfferDetail";
import {IOfferDetailApplication} from "../types/IOfferDetailApplication";

export const getOfferDetailApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getOfferDetail: build.query<IOfferDetail, number>({
            query: (offerId) => apiV2Link.offer.detail(Scenario.OFFER_DETAIL, {offerId})
        }),
        getOfferDetailApplication: build.query<IOfferDetailApplication, number>({
            query: (offerId) => apiV2Link.offer.detail(Scenario.OFFER_APPLICATION, {offerId})
        }),
        getOfferDetailMap: build.query<IMapOfferSidebar, number>({
            query: (offerId) => apiV2Link.offer.detail(Scenario.OFFER_DETAIL_MAP, {offerId})
        })
    })
});

export const {useGetOfferDetailQuery, useGetOfferDetailApplicationQuery, useGetOfferDetailMapQuery} = getOfferDetailApi;
